import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box } from '@mui/material';
import { ReactSortable } from 'react-sortablejs';
import { formatLabel } from './memberSummaryHelpers';
import { ReorderFieldsDialogProps } from '../utils/DataTypes';

const ReorderFieldsDialog: React.FC<ReorderFieldsDialogProps> = ({
  open,
  primaryView,
  tempOrder,
  setTempOrder,
  onClose,
  onSave,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>
        Reorder {primaryView === 'detailed' ? 'Detailed' : 'Rollup Sum'} Fields
        <span style={{ fontSize: '0.85rem', color: '#6b7280', marginLeft: 8 }}>({tempOrder.length} selected)</span>
      </DialogTitle>

      <DialogContent
        sx={{
          backgroundColor: '#f8fafc',
          p: 2.5,
          borderTop: '1px solid #e5e7eb',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 1.5,
            maxHeight: '60vh',
            overflowY: 'auto',
            pr: 1,

            '&::-webkit-scrollbar': { width: 6 },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#cbd5e1',
              borderRadius: 3,
            },
          }}
        >
          {primaryView === 'detailed' ? (
            <ReactSortable
              list={tempOrder.map((field) => ({ id: field, name: field }))}
              setList={(newList) => setTempOrder(newList.map((item) => item.name))}
              animation={150}
            >
              {tempOrder.map((field) => (
                <Box
                  key={field}
                  sx={{
                    p: 1.5,
                    m: 0.8,
                    border: '1px solid #d1d5db',
                    borderRadius: 2,
                    cursor: 'grab',
                    backgroundColor: '#ffffff',
                    textAlign: 'center',
                    fontWeight: 500,
                    fontSize: '0.95rem',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    transition: 'all 0.15s ease-in-out',
                    '&:hover': {
                      backgroundColor: '#f9fafb',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
                      transform: 'translateY(-1px)',
                    },
                    '&:active': {
                      cursor: 'grabbing',
                      backgroundColor: '#f3f4f6',
                      transform: 'scale(0.98)',
                    },
                  }}
                >
                  {formatLabel(field)}
                </Box>
              ))}
            </ReactSortable>
          ) : (
            <ReactSortable
              list={tempOrder.map((field) => ({ id: field, name: field }))}
              setList={(newList) => setTempOrder(newList.map((item) => item.name))}
              animation={150}
            >
              {tempOrder.map((field) => (
                <Box
                  key={field}
                  sx={{
                    p: 1.5,
                    m: 0.8,
                    border: '1px solid #d1d5db',
                    borderRadius: 2,
                    cursor: 'grab',
                    backgroundColor: '#ffffff',
                    textAlign: 'center',
                    fontWeight: 500,
                    fontSize: '0.95rem',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
                    transition: 'all 0.15s ease-in-out',
                    '&:hover': {
                      backgroundColor: '#f9fafb',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
                      transform: 'translateY(-1px)',
                    },
                    '&:active': {
                      cursor: 'grabbing',
                      backgroundColor: '#f3f4f6',
                      transform: 'scale(0.98)',
                    },
                  }}
                >
                  {formatLabel(field)}
                </Box>
              ))}
            </ReactSortable>
          )}
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" disabled={!tempOrder.length} onClick={() => onSave(tempOrder)}>
          Save Order
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReorderFieldsDialog;
